// extracted by mini-css-extract-plugin
export var active = "_80-1";
export var activeSubdued = "_80-2";
export var compact = "_80-3";
export var fill = "_80-6";
export var pulse = "_80-4";
export var settingHighlightPulse = "_80-5";
export var wrapper = "_80-0";